/**
 * Internal depedencies
 */
import { resetDashboardLayout } from 'state/dashboard-layouts/actions';
import { getLayoutId } from 'state/dashboard/selectors';

export default () => (dispatch, getState) => {
	const layoutId = getLayoutId(getState());
	return dispatch(resetDashboardLayout(layoutId));
};
